import { createContext } from "react";

const FeatureFlagContext = createContext(null);

export default FeatureFlagContext;
